// src/screens/MostruarioApps/MostruarioApps.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import './MostruarioApps.css';

// Importe as imagens e logos
import logoCalcLeite from "../../assets/calcleite.png";
import logoCalcCafe from "../../assets/calccafe.png";
import logoCalcBov from "../../assets/calcbov.png";
import logoCalcAgro from "../../assets/calcagro.png";
import imgLeite from '../../assets/app1.jpg';
import imgCafe from '../../assets/app3.jpg';
import imgBov from '../../assets/app4.jpg';
import imgAgro from '../../assets/app2.jpg';

const apps = [
    { 
        key: 'calcleite',
        logo: logoCalcLeite, 
        image: imgLeite,
        title: 'CalcLeite',
        description: 'Gestão completa para a pecuária de leite, do custo por litro à rentabilidade total do seu negócio.',
        available: true,
    },
    { 
        key: 'calccafe',
        logo: logoCalcCafe, 
        image: imgCafe,
        title: 'CalcCafé',
        description: 'Otimize sua lavoura de café com controle de custos preciso, análise de safra e projeções de lucro.',
        available: false,
    },
    { 
        key: 'calcbov',
        logo: logoCalcBov, 
        image: imgBov,
        title: 'CalcBov',
        description: 'Ferramentas especializadas para cria, recria e engorda. Maximize o desempenho do seu rebanho.',
        available: false,
    },
    { 
        key: 'calcagro',
        logo: logoCalcAgro, 
        image: imgAgro,
        title: 'CalcAgro',
        description: 'Gerencie os custos e a rentabilidade de diversas culturas agrícolas com simulações e relatórios detalhados.',
        available: false,
    },
];

const MostruarioApps = () => {
    const navigate = useNavigate();

    const handleAssinarClick = (appKey) => {
        // Navega para a tela de planos, passando a chave do app como parâmetro
        navigate(`/planos/${appKey}`);
    };

    return (
        <div className="mostruario-container">
            <div className="mostruario-header">
                <h1>Conheça Nossos Aplicativos</h1>
                <p>Escolha a ferramenta ideal para impulsionar a gestão do seu agronegócio.</p>
            </div>
            <div className="mostruario-grid">
                {apps.map((app) => (
                    <div key={app.key} className="app-showcase-card">
                        <div className="app-showcase-image-wrapper">
                            <img src={app.image} alt={app.title} className="app-showcase-image" />
                        </div>
                        <div className="app-showcase-content">
                            <img src={app.logo} alt={`Logo ${app.title}`} className="app-showcase-logo" />
                            <h2>{app.title}</h2>
                            <p>{app.description}</p>
                            <button 
                                onClick={() => handleAssinarClick(app.key)} 
                                className={`app-showcase-button ${!app.available ? 'disabled' : ''}`}
                                disabled={!app.available}
                            >
                                {app.available ? 'Assinar Agora' : 'Disponível em Breve'}
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MostruarioApps;